export default {
  menuCollapsed: true,
  amountSubscriptionAvailable: 0,
  products: [],
  isLoading: false,
  suggestions: [],
  suggestionsPagination: {},
};
